import healthMetricService from "../../components/services/healthMetricService";
import { logException } from "../../utils/AppInsightsLogging";
import dayjs from "dayjs";

import {
  FETCH_SMOKING_LOGS_REQUEST,
  FETCH_SMOKING_LOGS_SUCCESS,
  FETCH_SMOKING_LOGS_FAILURE,
} from "../constants";

const fetch_smoking_logs = () => {
  return {
    type: FETCH_SMOKING_LOGS_REQUEST,
  };
};

const fetch_smoking_logs_success = payload => {
  return {
    type: FETCH_SMOKING_LOGS_SUCCESS,
    payload,
  };
};

const fetch_smoking_logs_failed = error => {
  return {
    type: FETCH_SMOKING_LOGS_FAILURE,
    error,
  };
};

export const fetchSmokingLogs = userId => async dispatch => {
  dispatch(fetch_smoking_logs());

  try {
    const data = await healthMetricService.getSmokingLogsForUser(userId);
    const formattedData = data.map(log => ({
      ...log,
      date: dayjs(log.date).format("YYYY-MM-DD"),
    }));
    dispatch(fetch_smoking_logs_success(formattedData));
  } catch (error) {
    logException(error);
    dispatch(fetch_smoking_logs_failed(error));
  }
};
